export enum SiteProvider {
  SAMSUNG = 'portal',
  TRACFONE = 'mysites'
}
